var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tags.length ? _c('time-line-item-text', {
    attrs: {
      "color": _vm.isAdd ? 'success' : 'error',
      "icon": _vm.isAdd ? 'mdi-tag-plus' : 'mdi-tag-minus',
      "dense": true
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex flex-wrap align-center"
        }, [_c('span', {
          staticClass: "mr-1",
          domProps: {
            "innerHTML": _vm._s(_vm.textStart)
          }
        }), _vm._l(_vm.tags, function (tag) {
          return _c('tag-chip', {
            key: 'activity-timeline-tag-chip' + tag.id,
            attrs: {
              "value": tag,
              "size": "small"
            }
          });
        }), _c('span', {
          staticClass: "ml-1",
          domProps: {
            "innerHTML": _vm._s(_vm.textEnd)
          }
        })], 2)];
      },
      proxy: true
    }, {
      key: "menu",
      fn: function fn() {
        return [_vm.deleteUpdateActivity ? _c('div', [_vm.$vuetify.breakpoint.smAndDown ? _c('div', {
          staticClass: "mr-4"
        }, [_c('context-menu', [_c('activity-time-line-item-delete', {
          attrs: {
            "text": true,
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })], 1)], 1) : _c('activity-time-line-item-delete', {
          staticClass: "mr-4",
          attrs: {
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 667421737)
  }) : _c('div');
}
var staticRenderFns = []

export { render, staticRenderFns }